/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledSelectSkeleton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

// eslint-disable-next-line @mpb-com/mpb/single-styled-component, @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component -- Legacy code: do not use as an example.
export const StyledLabelSkeleton = styled(Skeleton).attrs({
    variant: SkeletonVariant.TEXT,
})`
    width: 50%;
    ${theme.typography.body_small}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

// eslint-disable-next-line @mpb-com/mpb/single-styled-component, @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledOptionSkeleton = styled(Skeleton).attrs({
    variant: SkeletonVariant.BLOCK,
})`
    width: 100%;
    height: 4.8rem;
`;
